/** Short pauses after a 401, long enough for a sign-in token to appear. */
export const SIGN_IN_RETRY_MS = [400, 900];

/**
 * Run `work` again when it fails because sign-in was not ready.
 * Any other failure stops immediately.
 */
export async function retryUnauthorized(work, {
  delays = SIGN_IN_RETRY_MS,
  wait = (ms) => new Promise((resolve) => { setTimeout(resolve, ms); }),
} = {}) {
  let attempt = 0;
  while (true) {
    try {
      return await work();
    } catch (err) {
      const status = Number(err?.status);
      if (status !== 401 || attempt >= delays.length) throw err;
      await wait(delays[attempt]);
      attempt += 1;
    }
  }
}
